import { connect } from 'react-redux';
import AllocatedRsrcRow from './AllocatedRsrcRow';
import { sortResourcesRequest, updateResourceFlag } from '../../../../../store/actions/allocatedResources.actions';
import { sortClientResourcesRequest} from '../../../../../store/actions/clients.actions';

const mapDispatchToProps = { sortResourcesRequest, sortClientResourcesRequest, updateFlag: updateResourceFlag };


export default connect(null, mapDispatchToProps)(AllocatedRsrcRow);